import axios from "../axios";

function unwrap(response) {
  return response?.data !== undefined ? response.data : response;
}

export async function getChemicalInventorySettings() {
  const response = await axios.get("/hse/chemical_inventory_settings");
  return unwrap(response);
}

export async function updateChemicalInventorySettings(payload) {
  const response = await axios.put("/hse/chemical_inventory_settings", {
    chemical_inventory_settings: payload,
  });
  return unwrap(response);
}
